<div class="cockpit-container">
  @for (item of componentsList; track item.id) {
    <div class="component-container">
      <ng-container
        *ngComponentOutlet="components[item.name]; inputs: {
          componentId: item.id
        }"
      >
      </ng-container>
    </div>
  }

  @if (componentsList.length === 0) {
    <div class="empty-cell">
      <div class="empty-cell-background"></div>
    </div>
  }
</div>